module.exports = "/virtual-football-league/img/amblems/right/logos/NewCastle.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/NewCastle.png
// module id = 2217
// module chunks = 4